import { useMutation } from '@apollo/client/react';
import { useContext } from 'react';
import { type BatchMoveProjectItemsMutation, type BatchMoveProjectItemsMutationVariables } from '../../__generated__/graphql-client-types';
import { ProjectSelectionContext } from '../../contexts/projects/project-selection/project-selection.context';
import { buildMoveCopyPayload, buildProjectGroupSources, getGroupsByProjectId } from '../../helpers/project/project.helper';
import { BATCH_UPDATE_PROJECT_GROUPS } from '../../queries/project/project-details.queries';
import { type SelectableProjectGroup } from '../../types/project.types';
import { useProjectId } from './project-details.hooks';

export const useProjectActions = () => {
	const projectId = useProjectId();
	const { selection } = useContext(ProjectSelectionContext);
	const [batchUpdateItems, { loading: loadingBatchUpdateItems }] = useMutation<
		BatchMoveProjectItemsMutation,
		BatchMoveProjectItemsMutationVariables
	>(BATCH_UPDATE_PROJECT_GROUPS);

	const moveOrCopyToProject = async (groups: SelectableProjectGroup[], isMoveView: boolean) => {
		const sources = buildProjectGroupSources(selection);
		const groupsByProject = getGroupsByProjectId(groups);

		await Promise.all(
			Object.entries(groupsByProject).map(async ([targetProjectId, projectGroups]) => {
				const payload = {
					projectId,
					targetProjectId: Number(targetProjectId) !== projectId ? Number(targetProjectId) : undefined,
					moveItems: isMoveView,
					sources,
					...buildMoveCopyPayload(projectGroups)
				};

				await batchUpdateItems({ variables: { input: payload } });
			})
		);
	};

	return {
		loadingBatchUpdateItems,
		moveOrCopyToProject
	};
};
